var map = {
	"./certificates/java_nptel.png": 35,
	"./certificates/pds_nptel.png": 36,
	"./certificates/python_nptel.png": 37,
	"./data": 5,
	"./data.js": 5,
	"./logos/acm.png": 38,
	"./logos/citi.jpg": 39,
	"./logos/ieee.png": 40,
	"./logos/ieee_compsoc.jpg": 41,
	"./logos/itkes.png": 42,
	"./logos/lakshya.jpg": 43,
	"./logos/marthoma.png": 44,
	"./logos/procode.jpg": 45,
	"./logos/ssn.svg": 46,
	"./logos/yrc.jpg": 47,
	"./profile-pic.jpeg": 48
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 11;